/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../../../.."
import BackButton from "../../../../components/Tablet/BackButton"
import ZyomuinInfo from "../../../../components/Tablet/ZyomuinInfo"
import { 区分分類コード } from "../../../../constant/enum/codes"
import { setAlerts } from "../../../../globalStore/alertStore"
import { 区分マスタ } from "../../../../service/master/kubun/TKubun"
import KubunService from "../../../../service/master/kubun/kubunService"
import { UpsertTenkoDetailFunctionContext } from "../../context/context"
import { CSS_PROPERTY } from "../../cssProperties/tablet"

const SiziZiko = () => {
  const dispatch: AppDispatch = useDispatch()
  const [指示事項, set指示事項] = useState<区分マスタ>()
  const UpsertTenkoDetailFunction = useContext(UpsertTenkoDetailFunctionContext)

  useEffect(() => {
    Promise.all([
      new KubunService().getList({
        分類コード: 区分分類コード.運行管理_勤怠.指示事項区分,
      }),
    ]).then(([res]) => {
      if (res) {
        let ランダム指示事項Number = Math.trunc(res.data.length * Math.random())
        let 指示事項Index =
          ランダム指示事項Number !== 0 ? ランダム指示事項Number - 1 : 0
        set指示事項(res.data[指示事項Index])
      }
    })
  }, [])

  const upsert点呼明細 = async () => {
    try {
      await UpsertTenkoDetailFunction({
        指示事項1テキスト: 指示事項?.名称1,
        指示事項1区分コード: 指示事項?.区分コード,
      })
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  return (
    <>
      <ZyomuinInfo />
      <table
        style={{ tableLayout: "fixed", height: CSS_PROPERTY.BODY_TABLE_HEIGHT }}
        className="w-100 mt-3">
        <tbody>
          <tr>
            <td colSpan={2}>本日の指示事項</td>
          </tr>
          <tr>
            <td colSpan={2}>
              <div
                style={{
                  height: "20rem",
                  ...CSS_PROPERTY.BORER_PROPERTIES,
                  backgroundColor: "white",
                  marginBottom: "1rem",
                  padding: "2rem",
                  verticalAlign: "top",
                }}>
                <div>事項番号: {指示事項 && 指示事項?.区分コード}</div>
                <div>{指示事項 && 指示事項?.名称1}</div>
              </div>
            </td>
          </tr>
          <tr>
            <td
              className="align-bottom"
              style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
              <BackButton />
            </td>
            <td className="text-end">
              <div
                className="d-inline-block"
                onTouchStart={upsert点呼明細}
                style={{
                  bottom: "0",
                  backgroundColor: CSS_PROPERTY.WARN_COLOR,
                  color: "white",
                  width: "25rem",
                  textAlign: "center",
                  ...CSS_PROPERTY.BORER_PROPERTIES,
                  marginBottom: "1rem",
                  padding: "0.5rem 1rem",
                }}>
                <span>点呼終わり</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default SiziZiko
